import type { DialogProps } from '@mui/material/Dialog';

import { StyledDialog as BaseStyledDialog } from './styles';

export type StyledDialogProps = DialogProps & {
  preventDismiss?: boolean;
};

export const StyledDialog = ({
  preventDismiss = false,
  onClose,
  ...dialogProps
}: StyledDialogProps) => {
  const handleClose: NonNullable<DialogProps['onClose']> = (event, reason) => {
    if (preventDismiss && reason === 'backdropClick') {
      return;
    }

    onClose?.(event, reason);
  };

  return (
    <BaseStyledDialog
      onClose={handleClose}
      {...dialogProps}
      disableEscapeKeyDown={preventDismiss || dialogProps.disableEscapeKeyDown}
    />
  );
};
